module.exports = __webpack_public_path__ + "static/top_sakai-59ad943d4c498247f5864a11396a5b02.png";